import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

// Check if we're hydrating (react-snap pre-rendered) or rendering fresh
const renderMethod = rootElement.hasChildNodes() ? 'hydrate' : 'render';

if (renderMethod === 'hydrate') {
  // react-snap pre-rendered, use hydration
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // Fresh render for development
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Ensure snapshots work
if (typeof window !== 'undefined') {
  window.snapSaveState = () => ({});
}
